import { optionTitle_timeProfiles } from './TimeProfileOption.locstring.json';
import { availabilityProfileOptionTitle } from './view/AvailabilityProfile.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import getShownView from './selectors/getShownView';
import TimeProfileShownView from './data/store/schema/TimeProfileShownView';

var lazyFullModule = new LazyModule(() => import('./lazyFullTimeProfileOption'));
let TimeProfileOption: LazyOption = createLazyOption(
    {
        key: 'timeProfileOption',
        titleStringKey: availabilityProfileOptionTitle,
        searchTermsStringKey: optionTitle_timeProfiles,
        isHidden: () => {
            return (
                !isFeatureEnabled('cal-timeBridge') || getShownView() != TimeProfileShownView.Main
            );
        },
    },
    lazyFullModule,
    m => m.default
);

export default TimeProfileOption;
